import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type SoundPayload = {
    soundName: string;
    spriteName: string;
    multiLanguages?: string[];
}

const initialState = {};

const soundSlice = createSlice({
  name: 'sound',
  initialState,
  reducers: {
    play(_, _action: PayloadAction<SoundPayload>) {},
    stop(_, _action: PayloadAction<SoundPayload>) {},
  },
});

export const soundActions = soundSlice.actions;
export default soundSlice.reducer;
